// Q.半年・年間定額プランを契約中ですが、プランをアップグレードしたいです。
export const UPGRADE_PAGE_URL = 'https://tayori.com/q/samurai-terakoya/detail/877945/';
